import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Grid } from '@mui/material';
import { useInView } from 'react-intersection-observer';

const MobileTime = () => {
  return (
    <Container sx={{ py: 5, position: 'relative', overflow: 'hidden' }}>
       <Box className='workflow' sx={{paddingBottom:'25px'}}>
            <Typography variant='h5' sx={{fontSize:"1.2rem"}} className='small_title'>Workflow</Typography>
            <Typography variant='h4'  sx={{fontSize:"1.6rem"}} className='title'>Our 3D Animation Workflow</Typography>
        </Box>

      <Box
       
        sx={{
            position: 'absolute',
            top: '8%',
            left: '8px',
            width: '3px',
            height: '81%',
            backgroundColor: '#039ad1',
            zIndex: -1,
        }}
        className="line"
      />

      <Grid container spacing={3}>
        <MobileTimelineBlock
          title="Concept Development"
          content="Brainstorm ideas and developing concept."
        />
        <MobileTimelineBlock
          title="Script Writing"
          content="This script outlines the dialogue or voiceover, actions or specific organs, parts and scenes of the animation."
        />
        <MobileTimelineBlock
          title="Storyboard and Animatic"
          content="Animatics are rough, simplified versions of the animation created using the storyboard images and recorded dialogue."
        />
        <MobileTimelineBlock
          title="Modeling & Staging"
          content="We create digital version of the props, environment, Character or Objects and we place it according to the scene requirment."
        />
        <MobileTimelineBlock
          title="Texturing & Lighting"
          content="Texturing involves adding surface detail and color to the 3D models and Lighting adds the mood and atmosphere."
        />
        <MobileTimelineBlock
          title="Animation"
          content="Animation is the process of bringing the characters and objects to life."
        />
        <MobileTimelineBlock
          title="Rendering"
          content="Rendering is the process of generating the final images from the 3D scene."
        />
        <MobileTimelineBlock
          title="VFX & Compositing"
          content="Compositing is the art of blending diverse visual element like VFX & Rendered layers into a harmonious masterpiece."
        />
        <MobileTimelineBlock
          title="Editing & SFX"
          content="Editing and SFX brings all the pre-production and post-production elements together and create the final output."
        />
        
      </Grid>
    </Container>
  );
};

interface MobileTimelineBlockProps {
  title: string;
  content: string;
}

const MobileTimelineBlock: React.FC<MobileTimelineBlockProps> = ({ title, content }) => {
  const { ref, inView, entry } = useInView({
    triggerOnce: false, // Keep tracking when the element enters and leaves
    threshold: 0.1,     // Trigger animation when 10% of the element is visible
  });

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (inView) {
      setIsVisible(true);  // Fade in when entering the viewport
    } else if (entry && entry.boundingClientRect.top > 0) {
      setIsVisible(false); // Fade out when scrolling up and out of view
    }
  }, [inView, entry]);

  return (
    <Grid item xs={12} ref={ref}>
      <Box
        sx={{
          position: 'relative',
          pl: 2,
          transform: isVisible ? 'translateX(0)' : 'translateX(-100%)',
          opacity: isVisible ? 1 : 0,
          transition: 'transform 0.8s ease-out, opacity 0.8s ease-out',
        }}
      >
        <Box
         sx={{
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            border: '2px solid #00afc1',
            backgroundColor:'#2d2d2d',
            position: 'absolute',
            top: '10px',
            left: '-15px',
            zIndex: '9999',
          }}
        />
        <Box sx={{ p: 2, bgcolor: 'background.paper', boxShadow: 3, borderRadius: 2 }} className="mob_workflow_cont">
          <Typography variant="h5" component="h3" fontWeight={500} className='title'>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" className='content'>
            {content}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};

export default MobileTime;
